import {
  Autocomplete,
  Chip,
  CircularProgress,
  FormControl,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { searchDocumentsByName } from "@/api/knowledgebase/knowledgebase.api";

const DocumentLinkAutocomplete = ({ title, field, value, setValue }: any) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [localValue, setLocalValue] = useState([]);
  const timeoutRef = useRef(null);

  const valueArray = value ? value.split(",").map((v: any) => v.trim()) : [];

  useEffect(() => {
    setLocalValue(valueArray);
  }, [value]);

  const fetchOptions = async (query: any, signal: any) => {
    setOptions(() => []);
    if (!query) {
      setOptions(() => []);
      return;
    }

    setLoading(true);

    try {
      const response = await searchDocumentsByName(query, signal);
      setOptions(() => response?.data?.Documents?.map((d: any) => d.doc_name) || []);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    if (!searchTerm) {
      setOptions([]);
      return;
    }
    
    timeoutRef.current = setTimeout(() => {
      fetchOptions(searchTerm, controller.signal);
    }, 300);
    
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      controller.abort();
    };
  }, [searchTerm]);

  const handleChange = (event: any, newValue: any) => {
    setLocalValue(newValue);
    const newValueString = newValue.join(", ");
    setValue(field, newValueString);
  };

  return (
    <FormControl fullWidth sx={{ maxWidth: "65%" }}>
      <Autocomplete
        multiple
        freeSolo
        options={options}
        value={localValue}
        onChange={handleChange}
        onInputChange={(event, newInputValue) => {
          setSearchTerm(newInputValue);
        }}
        filterOptions={(x) => x}
        renderInput={(params) => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip label={option} {...getTagProps({ index })} key={option} />
          ))
        }
      />
    </FormControl>
  );
};

export default DocumentLinkAutocomplete;
